import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="R" transform="translate(11.000000, 5.000000)">
        <path
          d="M28 62 L28 30 L44 30 C50 30 54 34 54 39 C54 43 51 46 47 47 L54 62 L48 62 L42 49 L33 49 L33 62 L34 62 Z M33 34 L33 45 L44 45 C47 45 49 43 49 40 C49 37 47 34 44 34 L33 34 Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
